import { UserService } from './../../core/services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/components/base/base.component';
import { ChangePassword } from 'src/app/core/models/change-password';
import { Student } from 'src/app/core/models/student';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { StudentService } from 'src/app/core/services/student.service';
import { NgForm } from '@angular/forms';
import { UploadService } from 'src/app/core/services/upload.service';

@Component({
  selector: 'app-student-settings',
  templateUrl: './student-settings.component.html',
  styleUrls: ['./student-settings.component.scss']
})
export class StudentSettingsComponent extends BaseComponent implements OnInit {
  @ViewChild('passForm', { static: false }) passForm: NgForm;

  userFullName: string;
  studentId: number;
  UserID: number;

  student = {} as Student;
  tokenValid: boolean;

  isTeacher: string;
  academyToken: string

  changePassword = {} as ChangePassword;
  loading = false;

  file: File = null;

  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private studentService: StudentService,
    private userService: UserService,
    private upload: UploadService,
  ) { super() }

  ngOnInit(): void {
    this.academyToken = localStorage.getItem('academyToken');
    this.userFullName = localStorage.getItem('userFullName');

    var studId = localStorage.getItem('studentId');
    this.studentId = Number(studId);

    var userId = localStorage.getItem('userId');
    this.UserID = Number(userId);

    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    this.isTeacher = isTeacher
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }
    
    this.loadData();
  }

  loadData() {
    this.route.data.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      data => {
        this.student = data.student.result.returnData as Student;
        // console.log(this.student)
      });
  }

  viewStudProfile(id) {
    this.router.navigate(['/student-profile/edit', this.studentId]);
  }

  viewStudCourses(id) {
    this.router.navigate(['/student-courses/edit', this.studentId]);
  }

  viewStudSettings(id) {
    this.router.navigate(['/student-settings/edit', this.studentId]);
  }

  viewWishlist(id) {
    this.router.navigate(['/wishlist/edit', this.studentId]);
  }

  saveStudent() {
    debugger
    this.loading = true;
    this.student.academyToken = this.academyToken;
    this.baseService.blockStart();
    this.studentService.save(this.student).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (apiData: any) => {
        this.loading = false;
        this.baseService.blockStop();
        if (apiData.result.message.type === 'Success')  {
          this.alertService.success(this.translate.instant('updated'));
          this.student = apiData.result.returnData as Student;
          localStorage.setItem('userFullName', this.student.name + ' ' + this.student.surname);
          this.router.navigate(['/home']);
        }
        else if (apiData.result.message.type === 'Error') {

          if (apiData.result.message.log.includes('The SSL connection')) {
            this.alertService.error(this.translate.instant('errorOcc'))
          }

          else {
            this.alertService.error(apiData.result.message.log)
          }
         
        }
        else {
          this.alertService.error(apiData.result.returnData);
        }
      },
      error => {
        this.loading = false;
        this.baseService.blockStop();
        this.alertService.error(this.translate.instant('loginerror'));
      }
    )
  }

  changePass() {
    debugger
    this.baseService.blockStart();
    this.changePassword.userId = this.UserID;
    this.changePassword.confirmNewPassword = this.changePassword.newPassword;
    this.userService.changePassword(this.changePassword).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.baseService.blockStop();
        if (data.success === true) {
          this.alertService.success(this.translate.instant('passchange'));
          this.changePassword = {} as ChangePassword;
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      },
      error => {
        this.baseService.blockStop();
        this.alertService.error(error);
      }
    )
  }

  changeInput1(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  changeInput2(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  changeInput3(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

  profilePic(event) {
    this.file = event.target.files[0];
    this.upload.upload(this.file).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      this.student.img = data.result.filePath;
    })
  }

}
